import { useState, useCallback } from 'react';
import { useAppDispatch } from '@/app/hooks';
import { fetchSiteImages } from '@/features/sites/sitesThunks';

interface UseSiteFilterReturn {
    selectedSite: string | null;
    handleSiteClick: (siteId: string) => void;
    handleClearFilter: () => void;
}

/**
 * Custom hook to manage site filtering state and actions
 * @returns Site filter state and handlers
 */
export const useSiteFilter = (): UseSiteFilterReturn => {
    const dispatch = useAppDispatch();
    const [selectedSite, setSelectedSite] = useState<string | null>(null);

    const handleSiteClick = useCallback((siteId: string) => {
        if (selectedSite === siteId) {
            setSelectedSite(null);
            dispatch(fetchSiteImages(null));
        } else {
            setSelectedSite(siteId);
            dispatch(fetchSiteImages(siteId));
        }
    }, [selectedSite, dispatch]);

    const handleClearFilter = useCallback(() => {
        setSelectedSite(null);
        dispatch(fetchSiteImages(null));
    }, [dispatch]);

    return {
        selectedSite,
        handleSiteClick,
        handleClearFilter
    };
};
